export default "__VITE_ASSET__CrmYCs2i__"